export default __webpack_public_path__ + "static/media/header_mobile.8237466c.png";